import React from 'react'
import OrderTracking from './Components/OrderTracking'

const App = () => {
  return (
    <div>
      <OrderTracking/>
    </div>
  )
}

export default App